/* eslint-disable complexity */
import { AppState } from 'src/app/store'
import { projectFormSectionHelpers } from './project-form-sections.helpers'

export const isSubmitProjectDisabledSelector = (appState: AppState): boolean => {
  const form = appState.projects.projectForm
  const { is_active } = form

  if (!form.kind) return true

  /* Global Fields on form NON ACTIVE */
  if (form.contributionProjectType === 'FREE_DONATION' && !is_active) {
    return [form.name, form.currency_token].includes(null)
  } else if (form.contributionProjectType !== 'FREE_DONATION' && !is_active) {
    return [form.name, form.volume_credits, form.currency_token].includes(null)
  }

  const sections = [
    projectFormSectionHelpers.isLocationCompleted(form),
    projectFormSectionHelpers.isContentCompelted(form),
    projectFormSectionHelpers.isPriceCompleted(form),
  ]

  if (is_active) {
    const isNotCompleted = sections.some(s => !s)
    if (form.kind === 'contribution' && form.is_tax_relief) {
      return !(projectFormSectionHelpers.isTaxReliefCompleted(form) && !isNotCompleted)
    }
    else if (form.kind !== 'contribution') {
      return !(
        !isNotCompleted &&
        projectFormSectionHelpers.isCertificationsCompleted(form) &&
        projectFormSectionHelpers.isDocumentationCompleted(form)
      )
    }
    return isNotCompleted
  }
  return false
}
